/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { IndexDependencies } from './dependenciesIndexClass.generated.js';
import { compareNaturalDependencies } from './dependenciesCompareNatural.generated.js';
import { sizeDependencies } from './dependenciesSize.generated.js';
import { subsetDependencies } from './dependenciesSubset.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSetMultiplicity } from '../../factoriesAny.js';
export var setMultiplicityDependencies = {
  IndexDependencies,
  compareNaturalDependencies,
  sizeDependencies,
  subsetDependencies,
  typedDependencies,
  createSetMultiplicity
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSetMultiplicity.generated.js
// module id = TaNL
// module chunks = 3